

export default {
  exampleCount: (state, getters) => {
    //return state.UslugeZaIspit.filter(x => x)
    return 0;
  }
  
}



// WEBPACK FOOTER //
// ./VueSrc/Common/Store/Exams/Exam_getters.js